import React, { Component } from 'react';
import { HeaderStore } from '../../mobx/exportMobx';
import { hashHistory } from '../../utils/histoty';
import './index.scss';

class Header extends Component {

	render() {
		let { logoIcon, phone, bgm, nameIcon } = HeaderStore;

		return (
			<div className="header">
				<img className="avatar" src={logoIcon} alt='' />
				<div className="contact">
					<img className="title" src={nameIcon} alt='' />
					{/* <span className="title"></span> */}
					{/* <span className="phone">{phone}</span> */}
				</div>
				<div className="icon">
					<a href={`tel:${phone}`} className="phone"></a>
					<span className="line" />
					<span className="address" onClick={this.clickAddress}></span>
					<span className="line" />
					<span className="music" onClick={this.clickMusic}></span>
				</div>

				{/* 背景音乐 */}
				<audio
					id="audioBgm"
					loop="loop"
					autoPlay="autoplay"
				>
					<source src={bgm} type="audio/mpeg" />
				</audio>
			</div>
		);
	}

	componentDidMount = () => {
		// iphone不能自动播放音频，通过触摸屏幕任何地方模拟播放
		window.wx.ready(function () {
			var audio = document.getElementById('audioBgm');
			audio.play();
		});
	}

	//点击导航图标
	clickAddress = () => {
		hashHistory.push('/map');
	}

	// 点击音乐图标
	clickMusic = () => {
		let { musicActive } = HeaderStore;
		const audioBgm = document.getElementById(`audioBgm`);
		musicActive ? audioBgm.pause() : audioBgm.play();
		HeaderStore.musicActive = !musicActive;
	}

}

export default Header;
